export const STATUS = {
    STATUS_HOT: 1,
    STATUS_WARM: 2,
    STATUS_COLD: 3,
    STATUS_PRESALES_CLOSE: 4,
    STATUS_COMPLETED: 5,
    STATUS_CLOSED: 6,
    STATUS_REJECTED: 7,
    STATUS_APPROVE_PENDING: 8,
    CITY_HEAD: 17,
    SALES_COORDINATOR: 4,
    NATIONAL_HEAD: 3,
    NATIONAL_HEAD_OPERATIONS: 16,
    CORPORATE: 1,
    APARTMENT: 2,
    B2BALLIANCE: 3,
    SUPPLY: 4,
    WAREHOUSE: 5,
    LOCATION_TYPE: 3,
    PARKING_TEAM_CORDINATOR:38
}